import { useTranslation } from 'react-i18next';

export function GardenFloorControl({ value, onChange }: { value: number; onChange: (opacity: number) => void }) {
  const { t } = useTranslation();
  const percent = Math.round(value * 100);
  const valueText = t(percent === 0 ? 'personal.floorHidden' : 'personal.floorPercent', { count: percent });
  return <div className="floor-control">
    <div><label htmlFor="floor-opacity">{t('personal.floor')}</label><output htmlFor="floor-opacity">{valueText}</output></div>
    <input id="floor-opacity" type="range" min="0" max="100" step="1" value={percent} aria-valuetext={valueText} aria-describedby="floor-note" onChange={event => onChange(Number(event.target.value) / 100)} />
    <p id="floor-note">{t('personal.floorNote')}</p>
  </div>;
}
